// src/features/Auth/authSelectors.ts
import { RootState } from "@/app/store";

export const selectAuth = (state: RootState) => state.auth;

export const selectUser = (state: RootState) => state.auth.user;

export const selectPracticeInfo = (state: RootState) => state.auth.practice;

export const selectTwoWayTextEnabled = (state: RootState) => state.auth.practice?.twoWayTextEnabled === 1 ? true : false;

export const selectUserList = (state: RootState) => state.auth.list;

export const selectUserProfileImage = (state: RootState) => state.auth.list[0]?.userProfileImage;

export const selectUserFirstName = (state: RootState) =>
  state.auth.user?.firstName ?? "";

export const selectUserFullName = (state: RootState) => {
  const first = state.auth.user?.firstName ?? "";
  const middle = state.auth.user?.middleName ?? "";
  const last = state.auth.user?.lastName ?? "";

  return `${first} ${middle} ${last}`.trim().replace(/\s+/g, " ");
};

export const selectAuthUserId = (state: RootState) =>
  state.auth.user?.authUserId ?? null;

export const selectUserEmail = (state: RootState) =>
  state.auth.user?.email ?? "";

export const selectUserType = (state: RootState) =>
  state.auth.userTypeLabel ?? "";

export const selectIsAuthenticated = (state: RootState) =>
  !!state.auth.token;

export const selectPortalAccountId = (state: RootState) =>
  state.auth.user?.portalAccountFkey ?? null;

export const selectProviderId = (state: RootState) =>
  state.auth.user?.id ?? null;

export const selectProviderCode = (state: RootState) =>
  state.auth.user?.providerCode ?? null;

export const selectAvailableFacilities = (state: RootState) => 
  state.auth.availableFacilities;

export const selectHasMultipleFacilities = (state: RootState) =>
  state.auth.availableFacilities && state.auth.availableFacilities.length > 1;